exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".avatar .icon {\n  font-size: 40px;\n  height: 144px;\n  width: 144px;\n  max-width: 176px;\n  font-weight: 800;\n  line-height: 48px; }\n\n.product-container {\n  padding: 20px; }\n", ""]);

// exports
